export const shareSystemsActive = (demandHeader) => {
    const arr = [];
    if (!!(demandHeader?.applicationClientSettings?.ezdpuwIntegration?.active)) {
        arr.push("ezdpuw")
    }
    return arr;
}

export const shareSystemsConnected = (demandHeader) => {
    const arr = [];
    if (!!(demandHeader?.applicationClientSettings?.ezdpuwIntegration?.connected)) {
        arr.push("ezdpuw")
    }
    return arr;
}